import * as React from "react";
import { useScale } from "./scale";

export const HEADER = {
    H: 80,
    LPAD: 56,
    RPAD: 56,
    TPAD: 41,
    TITLE_FZ: 38,
    ICON: 60,
} as const;

export const withBase = (p: string) =>
    (import.meta.env.BASE_URL || "./") + p.replace(/^\/+/, "");

type HeaderProps = {
    title: string;
    icon?: string;
    backIcon?: string;
    onBack?: () => void;
    onTitleClick?: () => void;
    onIconClick?: () => void;
    right?: React.ReactNode;
    style?: React.CSSProperties;
};

export function Header({
                           title,
                           icon,
                           backIcon,
                           onBack,
                           onTitleClick,
                           onIconClick,
                           right,
                           style,
                       }: HeaderProps) {
    const { px } = useScale();
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: px(HEADER.LPAD),
                paddingRight: px(HEADER.RPAD),
                paddingTop: px(HEADER.TPAD),
                paddingBottom: px(16),
                boxSizing: "border-box",
                width: "100%",
                ...style,
            }}
        >
            {onBack && backIcon && (
                <button
                    onClick={onBack}
                    aria-label="뒤로 가기"
                    style={{
                        lineHeight: 0,
                        marginRight: px(12),
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                    }}
                >
                    <img
                        src={backIcon}
                        alt=""
                        style={{ width: px(48), height: px(48), display: "block" }}
                    />
                </button>
            )}

            {onTitleClick ? (
                <button
                    onClick={onTitleClick}
                    style={{
                        fontSize: px(HEADER.TITLE_FZ),
                        fontWeight: 800,
                        color: "#111",
                        background: "transparent",
                        border: "none",
                        padding: 0,
                        margin: 0,
                        cursor: "pointer",
                    }}
                >
                    {title}
                </button>
            ) : (
                <span
                    style={{ fontSize: px(HEADER.TITLE_FZ), fontWeight: 800, color: "#111" }}
                >
          {title}
        </span>
            )}

            {icon && (
                <button
                    onClick={onIconClick || onTitleClick}
                    aria-label="헤더 아이콘"
                    style={{
                        background: "transparent",
                        border: "none",
                        lineHeight: 0,
                        marginLeft: px(12),
                        cursor: onIconClick || onTitleClick ? "pointer" : "default",
                    }}
                >
                    <img
                        src={icon}
                        alt=""
                        style={{ width: px(HEADER.ICON), height: px(HEADER.ICON), display: "block" }}
                    />
                </button>
            )}

            {right && <div style={{ marginLeft: "auto" }}>{right}</div>}
        </div>
    );
}
